import { selectIsAudienceViewExpanded } from "modules/broadcast/AudienceView/selectors";
import { useI18n } from "i18n";
import { useSelector } from "react-redux";
import { ActionButton } from "modules/actionButton";
import { useAudienceViewActions } from "../AudienceView/useAudienceView";
import ExpandedIcon from "./assets/AudienceIconExpanded.svg";
import Icon from "./assets/AudienceIcon.svg";
import { selectIsAudienceViewEnabled } from "../../event/selectors";

const AudienceViewIcon = () => {
  const { setIsExpanded } = useAudienceViewActions();
  const isExpanded = useSelector(selectIsAudienceViewExpanded);
  const { t } = useI18n();
  const isAudienceViewEnabled = useSelector(selectIsAudienceViewEnabled);

  if (!isAudienceViewEnabled) return null;

  return (
    <ActionButton
      label=""
      onClick={() => setIsExpanded(!isExpanded)}
      aria-label={t("audience.view.toggle")}
      icon={
        <img
          height="28px"
          width="28px"
          src={isExpanded ? ExpandedIcon : Icon}
          alt={t("audience.view.toggle")}
        />
      }
      darkMode
    />
  );
};

export default AudienceViewIcon;
